<template>
  <VBtn flat @click="showPasswordModal">Create password</VBtn>
</template>

<script setup lang="ts">
  import VBtn from '~/misc/v-btn';

  const PasswordModal = defineAsyncComponent(
    () => import('~/misc/user-resource/manage/password/modal/UserResourcePasswordModal.vue')
  );

  const props = defineProps({
    userId: {
      type: Number,
      required: true,
    },
    userEmail: {
      type: String,
      required: true,
    },
  });

  const { show: showModal } = useModal();

  const showPasswordModal = () =>
    showModal(PasswordModal, {
      userId: props.userId,
      userEmail: props.userEmail,
    });
</script>
